import React from 'react';
import { Col, Row } from 'reactstrap';
import moment from 'moment';
import ProductItem from './productItem';

const TransactionItem = (props) => {
  const { transaction } = props;

  return (
    <div className="transaction-item">
      <Row>
        <Col>
          {
            transaction?.products?.map((p, i) => (
              <>
                <ProductItem key={p.id} product={p} />
                {
                  i !== transaction?.products.length - 1
                    ? (<div className="mb-4 ml-2" style={{ borderBottom: '2px solid #cbcbcb' }} />)
                    : ''
                }
              </>
            ))
          }
        </Col>
        <Col xs="auto" className="mr-2" style={{ paddingTop: '10px' }}>
          <p style={{ color: '#224B71' }}>
            注文日：
            {moment(transaction.created_at).format('YYYY.MM.DD')}
          </p>
          <p style={{ color: '#224B71' }}>
            注文番号：
            {transaction.id}
          </p>
        </Col>
      </Row>
      <div className="mb-4 mr-2 ml-2" style={{ borderBottom: '2px solid #cbcbcb' }} />
      <h4 className="pl-4">
        {' '}
        支払い金額：￥
        {transaction.price.toLocaleString()}
      </h4>
    </div>
  );
};
export default TransactionItem;
